export function postsExtractor(content) {
	// old solution
	// message.content.split('\n').filter((msg)=>msg.length > 10);

		// via solution
		// const separatorPattern = /(\r?\n){2,}[#*]+[\s#*]*.*?(\r?\n)/g;
		// const parts = content.split(separatorPattern);
		// const posts = [];
		// for (const part of parts) {
		// 	if (!part.trim()) continue;
		// 	const postMatch = part.match(/(?:Пост|Post):\s*"([\s\S]*?)"/i);
		// 	if (postMatch) {
		// 		posts.push(postMatch[1].trim());
		// 	}
		// }
		// return posts;


	const quotedPostRegex = /(?:Пост|Post):\s*"([^"]+)"/gi;

	const postRegex = /(?:^|\n)(?:---|\*\*|\#{2,})\s*\n\s*\*\*(?:Пост|Post)\s*\d+:.*?\*\*\s*\n([\s\S]*?)(?=\n(?:---|\*\*|\#{2,})|$)/gi;

	const altPostRegex = /(?:^|\n)(?:---|\*\*|\#{2,})\s*\n\s*\*\*(?:Пост|Post)\s*\d+:.*?\*\*\s*\n\n([\s\S]*?)(?=\n(?:---|\*\*|\#{2,})|$)/gi;

	const simplePostRegex = /(?:^|\n)(?:---|\#{2,})\s*\n(?:Пост|Post)\s*\d+:.*?\n\n([\s\S]*?)(?=\n(?:---|\#{2,})|$)/gi;

	const posts = [];
	let match;

	while ((match = postRegex.exec(content))) {
		const postContent = match[1].trim();
		if (postContent) {
			posts.push(postContent);
			continue;
		}
	}

	while ((match = postRegex.exec(content))) {
		const postContent = match[1].trim();
		if (postContent) {
			posts.push(postContent);
		}
	}

	if (posts.length === 0) {
		while ((match = altPostRegex.exec(content))) {
			const postContent = match[1].trim();
			if (postContent) {
				posts.push(postContent);
			}
		}
	}

	if (posts.length === 0) {
		while ((match = simplePostRegex.exec(content))) {
			const postContent = match[1].trim();
			if (postContent) {
				posts.push(postContent);
			}
		}
	}

	if (posts.length === 0) {
		while ((match = altPostRegex.exec(content))) {
			const postContent = match[1].trim();
			if (postContent) {
				posts.push(postContent);
			}
		}
	}

	if (posts.length === 0) {
		while ((match = quotedPostRegex.exec(content))) {
			const postContent = match[1].trim();
			if (postContent) {
				posts.push(postContent);
			}
		}
	}

	return posts.filter(post => post.length > 0).map(post => post.trim()).map(cleanPost);
}

function cleanPost(post) {
	return post
			.replace(/^(?:\*\*)?(?:Пост|Post)\s*\d*\s*[:*]*\s*(?:\*\*)?/i, '')
			.trim();
}